// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ApplicationLoader_wrapper__jhVap","hidden":"ApplicationLoader_hidden__OyVPX","loader":"ApplicationLoader_loader__Nj5Xy","logo":"ApplicationLoader_logo__eLDv7"};